import { render, staticRenderFns } from "./ModalBeds.vue?vue&type=template&id=01296f5d&"
import script from "./ModalBeds.vue?vue&type=script&lang=js&"
export * from "./ModalBeds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports